import React, { Component } from 'react'
import { graphql } from 'gatsby'
import { Columns, Column, Container, Content, Hero, HeroBody, Subtitle, Title } from 'bloomer'
import styled from 'styled-components'

// import Breadcrumbs from '../../components/breadcrumbs'
import CallsToAction from '../../components/ctas'
import GetStarted from '../../components/start'
import Head from '../../components/head'
import Image from '../../components/image'
import Layout from '../../components/layout'
import Next from '../../components/next'

import proposalFeatures from '../../content/features/proposal-generator'

const FeatureHighlight = styled.div`
  align-items: center;
  display: flex;
  flex-flow: column nowrap;
  height: 25rem;
  justify-content: center;
  width: 100%;

  @media only screen and (min-width: 32rem) {
    display: block;
  }
`

const ShortHeroBody = styled(HeroBody)`
  padding-top: 3rem !important;

  @media only screen and (min-width: 45rem) {
    padding-top: 9rem !important;
  }
`

const ReversibleColumns = styled(Columns)`
  display: flex;
  flex-flow: column-reverse nowrap;

  @media only screen and (min-width: 45rem) {
    flex-flow: row nowrap;
  }
`

const MockupNeighborColumn = styled(Column)`
  @media only screen and (min-width: 45rem) {
    padding-left: 8rem !important;
  }
`

class Proposal extends Component {
  render() {
    const featureHighlights = proposalFeatures.map((feature, i) => (
      <Column key={i} isSize={{ default: 4, mobile: 'full' }}>
        <FeatureHighlight>
          <Image alt={feature.title} file={this.props.data[feature.icon]} />
          <Subtitle isSize={4} style={{ fontWeight: 700, margin: '2rem 0' }}>
            {feature.title}
          </Subtitle>
          <Content isSize={'medium'} style={{ margin: '0 1rem' }}>
            {feature.description}
          </Content>
        </FeatureHighlight>
      </Column>
    ))

    let HeroSection = (
      <Hero isColor={'light'} isSize={'large'}>
        <ShortHeroBody>
          <Container hasTextAlign="right" style={{ paddingBottom: '4rem' }}>
            <ReversibleColumns isGrid>
              <Column isSize={{ default: 5, mobile: 'full' }} style={{ display: 'flex', alignItems: 'center' }}>
                <Image
                  alt={'Route Proposal Generator Screen'}
                  file={this.props.data.proposalDragAndDrop}
                  style={{ width: '100%' }}
                />
              </Column>
              <Column isSize={{ default: 7, mobile: 'full' }}>
                <Title hasTextAlign="right" isSize={1} className={'huge'}>
                  Proposal Generator
                </Title>
                <Subtitle hasTextAlign="right" isSize={3}>
                  Go from new lead to approved proposal effortlessly.
                </Subtitle>
                <CallsToAction />
              </Column>
            </ReversibleColumns>
          </Container>
        </ShortHeroBody>
      </Hero>
    )

    let FeatureHighlightsSection = (
      <Hero isColor={'black'} isSize={'medium'}>
        <HeroBody>
          <Container hasTextAlign={'centered'}>
            <Subtitle isSize={1}>
              Creating polished and customized proposals is a tedious and time consuming process. Not anymore.
            </Subtitle>
            <Columns hasTextAlign={'centered'} isGrid style={{ justifyContent: 'center', marginTop: '4rem' }}>
              {featureHighlights}
            </Columns>
          </Container>
        </HeroBody>
      </Hero>
    )

    let FeatureOne = (
      <Hero isColor={'light'} isSize={'medium'}>
        <HeroBody>
          <Container>
            <Subtitle isSize={1}>Start Impressing Prospects Today</Subtitle>
            <Subtitle isSize={2}>Complete control, endless customization</Subtitle>
            <Columns isGrid style={{ alignItems: 'center', marginTop: '4rem' }}>
              <Column isSize={{ default: 6, mobile: 'full' }}>
                <Image
                  file={this.props.data.proposalServiceDays}
                  alt={`generated days of service section by proposal generator`}
                />
              </Column>
              <MockupNeighborColumn isSize={{ default: 6, mobile: 'full' }}>
                <Content isSize={'medium'}>
                  Generate proposals with fully editable what-you-see-is-what-what-you get markdown fields and view your
                  proposal creation in real time. Create error-free proposals with pre-built drag and drop elements
                  anywhere you want them for on-the-fly customization.
                </Content>
                <Content isSize={'medium'}>
                  Really impress your client's by going the extra mile. With just a few clicks you can make your
                  proposals stand above the rest by adding detailed information about the client and location.
                </Content>
                <ul>
                  <li>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      ADD PROSPECT & CLIENT LOGOS
                    </Subtitle>
                  </li>
                  <li>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      CUSTOM SERVICE CHARGES
                    </Subtitle>
                  </li>
                  <li>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      TEMPLATED SCOPE OF WORK
                    </Subtitle>
                  </li>
                  <li>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      LEGAL VERBIAGE WITH ONE CLICK
                    </Subtitle>
                  </li>
                </ul>
              </MockupNeighborColumn>
            </Columns>
          </Container>
        </HeroBody>
      </Hero>
    )

    let FeatureTwo = (
      <Hero isColor={'light'} isSize={'large'}>
        <HeroBody>
          <Container>
            <Subtitle isSize={1}>Get Your Proposals Out The Door</Subtitle>
            <Subtitle isSize={2}>Time Saving Professionalism</Subtitle>
            <Content isSize={'large'}>
              Get your proposals out the door in record time by using Route's pre-built Scope of Work templates. Build
              out your own library of templates and custom elements to save time and send winning proposals every time.
            </Content>
            <Columns isGrid style={{ alignItems: 'center', marginTop: '4rem' }}>
              <Column isSize={{ default: 6, mobile: 'full' }}>
                <Image
                  file={this.props.data.proposalScopeOfWork}
                  alt={`generated scope of work section by proposal generator`}
                />
              </Column>
              <MockupNeighborColumn isSize={{ default: 6, mobile: 'full' }}>
                <Subtitle isSize={3}>Generated Scope of Work</Subtitle>
                <Content isSize={'medium'}>
                  Don't waste precious time typing out your scope of work any longer. Based on the room types from your
                  Walkthrough or by selecting a location type, a pre-templated list of tasks broken out for each area
                  will appear that you can modify however you need. Save your own Scope of Works for you and your team
                  to reuse.
                </Content>
                <Subtitle isSize={3}>Custom Elements</Subtitle>
                <Content isSize={'medium'}>
                  Create and save custom elements that impress clients and save you time. Easily create custom "About
                  Us" sections, upload your marketing material, and more. The options are endless.
                </Content>
              </MockupNeighborColumn>
            </Columns>
          </Container>
        </HeroBody>
      </Hero>
    )

    let FeatureThree = (
      <Hero isColor={'light'} isSize={'medium'}>
        <HeroBody>
          <Container>
            <Subtitle isSize={1}>Close the Deal</Subtitle>
            <Subtitle isSize={2}>Customers appreciate when it's all about them</Subtitle>
            <Content isSize={'large'}>
              Give your proposals the razor-sharp edge needed to cut through the competition and close deals. Create
              stunning, professional sales documents tailored for your clients.
            </Content>
            <Columns isGrid style={{ alignItems: 'center', marginTop: '4.5rem' }}>
              <Column isSize={{ default: 6, mobile: 'full' }}>
                <Image
                  file={this.props.data.proposalCustomization}
                  alt={`customization options in proposal generator`}
                />
              </Column>
              <MockupNeighborColumn
                isSize={{ default: 6, mobile: 'full' }}
                hasTextAlign={'right'}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <ul>
                  <li style={{ marginBottom: '2rem' }}>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      Deep Customization
                    </Subtitle>
                    <Content isSize={'medium'}>
                      Customize the colors of your letterhead, headers, and more to match your company colors or the
                      clients. Upload their logo for even more of a personal touch.
                    </Content>
                  </li>
                  <li style={{ marginBottom: '2rem' }}>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      Show Them You Care
                    </Subtitle>
                    <Content isSize={'medium'}>
                      Go the extra mile by importing real photos of areas at the client's location that make it apparent
                      that you will provide outstanding service by using Route's Walkthrough Builder. Already start
                      showing how much you care.
                    </Content>
                  </li>
                  <li style={{ marginBottom: '2rem' }}>
                    <Subtitle isSize={4} style={{ fontWeight: '600' }}>
                      Endless Possibilities With Image Elements
                    </Subtitle>
                    <Content isSize={'medium'}>
                      Whether you want to personalize your proposal with a photo of your team, add your certifications,
                      or market your other services - you can do it all with the Image element.
                    </Content>
                  </li>
                </ul>
              </MockupNeighborColumn>
            </Columns>
          </Container>
        </HeroBody>
      </Hero>
    )

    return (
      <Layout>
        <Head
          author={'Route'}
          banner={this.props.data.proposalDragAndDrop}
          title={'Proposal Generator: Create Customized Proposals With Route'}
          description={`The Route Platform's Proposal Generator is the ultimate sales tool for creating visually stunning custom proposals.`}
          keywords={['Route', 'proposal', 'proposal generator', 'SaaS', 'software for service companies']}
          {...this.props}
        />
        {/* <Breadcrumbs {...this.props} /> */}
        {HeroSection}
        {FeatureHighlightsSection}
        {FeatureOne}
        {FeatureTwo}
        {FeatureThree}
        {/* <Next
          style={{ marginTop: '3.5rem' }}
          to={'/features/workflow-management'}
          title={'Next Up: Workflow Management'}
        /> */}
        <Next
          style={{ marginTop: '3.5rem' }}
          to={'/features/inspection-reports'}
          title={'Next Up: Inspection Reports'}
        />
        <GetStarted />
      </Layout>
    )
  }
}

export const query = graphql`
  query {
    proposalCustomization: file(relativePath: { eq: "assets/mockups/proposal-customization.gif" }) {
      extension
      publicURL
    }
    proposalDragAndDrop: file(relativePath: { eq: "assets/mockups/drag-and-drop-proposals.png" }) {
      ...FluidImage
    }
    proposalScopeOfWork: file(relativePath: { eq: "assets/mockups/proposal-scope-of-work.gif" }) {
      extension
      publicURL
    }
    proposalServiceDays: file(relativePath: { eq: "assets/mockups/proposal-service-days.gif" }) {
      extension
      publicURL
    }
    customization: file(relativePath: { eq: "assets/icons/flaticon/customization.png" }) {
      childImageSharp {
        fixed(width: 144, height: 144) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    importWalkthrough: file(relativePath: { eq: "assets/icons/flaticon/import-walkthrough.png" }) {
      childImageSharp {
        fixed(width: 144, height: 144) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    convertToPDF: file(relativePath: { eq: "assets/icons/flaticon/convert-to-pdf.png" }) {
      childImageSharp {
        fixed(width: 144, height: 144) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

export default Proposal
